import dayjs from "dayjs";

/**
 * Sample temperature input mode helpers.
 *
 * @see docs/engineering/receive-rules.md
 */

export type SampleTempFields = {
  temp?: unknown;
  tempType?: string | null;
};

export type SampleTempMode = "enum" | "explicit";

/**
 * Receive flow: enum ranges when packing time exists and shipment is ≤48h old
 * (evaluated against current time at receive).
 */
export function requiresEnumTempAtReceive(
  packedAt: Date | string | null | undefined,
): boolean {
  if (!packedAt) return false;
  return dayjs().diff(packedAt, "hour", true) <= 48;
}

/** Infer how a sample's received temperature was recorded. */
export function inferStoredSampleTempMode(
  sample: SampleTempFields,
): SampleTempMode | null {
  if (sample.tempType != null) return "enum";
  if (sample.temp != null) return "explicit";
  return null;
}

/**
 * Sample edit flow: preserve stored receipt mode when present so unrelated edits
 * are not blocked by the 48-hour clock. Falls back to receive rules when no
 * temperature is stored yet.
 */
export function usesEnumTempForSampleEdit(
  sample: SampleTempFields,
  packedAt: Date | string | null | undefined,
): boolean {
  const storedMode = inferStoredSampleTempMode(sample);
  if (storedMode === "enum") return true;
  if (storedMode === "explicit") return false;
  return requiresEnumTempAtReceive(packedAt);
}
